import type { FaireProductEntity } from "../../entity_types/product";

export const p_49fbb42d51: FaireProductEntity = {
  token: "p_49fbb42d51",
  type: "product",
  name: "Villa Real Mexican Hot Chocolate",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/fce9e1c15b5336c5fb5b27c9e22ff744d3f81daff6ca97c133d1d7b6638960dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6970abccc295fbc5a8813e4fb879764ca3107c4c996df296661c32f9370d8e3c.jpeg",
    "https://cdn.faire.com/fastly/b59234468e074b582373d29adba29c13cb4873fb73885e6e67ac4f8e1d463098.jpeg",
    "https://cdn.faire.com/fastly/9e3587fc4574778ec46da0a80d0e027e6aecab2d974d31322984b4d824f8538a.jpeg",
    "https://cdn.faire.com/fastly/d0dff303cb21e58868d6cddab080fcf7ace3ae405347d1a1b2a794d46b4a3fb3.jpeg",
    "https://cdn.faire.com/fastly/6e817a2758f514ad4fe05f192ab481e5cb57b273782d7562a0f45fecf8d908ac.jpeg",
    "https://cdn.faire.com/fastly/aeae7a30214170006b0c3aa391ed90f4bb391c7637a2f65ee3610c5a664c1af3.jpeg",
    "https://cdn.faire.com/fastly/489954f6b125b89979f9bc9fe6c87c999bf4329a1674a314e08f1b1b037aea26.jpeg",
    "https://cdn.faire.com/fastly/a65e7b14a707536541cd909f9d276ce1f466c1c13143ed5a6790fa97cc55d8e7.jpeg",
    "https://cdn.faire.com/fastly/207975b3eae39761c951e5bc8089f2d79447acc698400d4d91cef250eb5da25b.jpeg",
  ],
  priceDollars: 7,
  description:
    "Villa Real chocolate from Oaxaca is made with simple ingredients of cocoa butter, sugar, almond, and other nuts and spices, resulting in the most delicious cup of Mexican Hot Chocolate you’ve ever tasted. Mix with warm milk and froth together with our handcrafted traditional molinillo. (Jug and Molinillo not included).\n\nSmall size is 250g, including 5 discs of Chocolate.\n\nIngredients: \nCocoa butter, sugar, almond, nuts and spices\nAllergen statement: Includes nuts\nMade in Mexico\n",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:23.092Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
